import axios from "axios";

let config = require("../configuration/config");

axios.defaults.withCredentials = true;

export default axios.create({
  baseURL: config.serverUrl,
});
